export default {
  name: 'en',
  el: {},
}
